import request from "../clientsApi";
import { API_ROUTES } from "../../config/baseURL";

export const apiGetExcludedActivitiesBySubgroup = async (grupo = "", subgrupo = "") => {
  const res = await request(API_ROUTES.getExcludedActivitiesBySubgroup(grupo, subgrupo), {
    method: "GET",
  });

  return res.json();
};

export const apiGetAvailableExcludedActivities = async () => {
  const res = await request(API_ROUTES.getAvailableExcludedActivities, {
    method: "GET",
  });

  return res.json();
};

export const apiSaveExcludedActivitiesBySubgroup = async (payload) => {
  const res = await request(API_ROUTES.saveExcludedActivitiesBySubgroup, {
    method: "POST",
    body: JSON.stringify(payload),
  });

  return res.json();
};

export const apiDeleteExcludedActivityBySubgroup = async (payload) => {
  const res = await request(API_ROUTES.deleteExcludedActivityBySubgroup, {
    method: "POST",
    body: JSON.stringify(payload),
  });

  return res.json();
};
